export default __webpack_public_path__ + "3f9df646571e56e1c0a0ef40dcf90bdb.webp";